import config from "../config";
import {Collection, Outfit} from "./models";
import {SpecialCollection} from "./collection";
import styles from  "./outfit-image.scss";

export class OutfitImage extends HTMLElement {
  /** The position in CSP-Admin */
  position: number;
  /** The aspect ratio e.g. 1:1, 2:3, 3:2, 3:4, 9:16, 16:9 */
  private frame: string;
  /** The resolution quality e.g. 'low', 'mid', 'high' 'higher', 'full-hd' */
  private resolution: string;
  /** The outfit itself */
  private outfit: Outfit;
  /** Should the outfitImage be hidden in the gallery */
  isHidden: boolean;

/** Holds an internal state of whether the element was initialized before */
  private isInitialized: boolean;

  updateCallback: (source: OutfitImage) => (() => any);

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.isInitialized) {return}
    this.addEventListener("click", this.onClick.bind(this));

    this.position = parseInt(this.getAttribute('position')) || this.position;
    this.frame = this.getAttribute('frame') || this.frame;
    this.resolution = this.getAttribute('resolution') || this.resolution;
    this.isHidden = !!this.hasAttribute('hide-gallery');

    this.registerUpdateCallback();
    this.innerHTML = `<style>${styles}</style>`
    this.isInitialized = true;
  }

  private registerUpdateCallback() {
    let root = this.parentElement;
    while (!(root instanceof SpecialCollection) && root != null) {
      root = root.parentElement
    }

    if (root != null) {
      const collection = root as SpecialCollection
      if (collection) {
        this.updateCallback = collection.outfitImageUpdateCallback
      }
    }
  }

  static get observedAttributes() { return ['position']; }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'position') {
      this.position = parseInt(newValue);
      if (this.updateCallback) {
        this.updateCallback(this)()
      }
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick)
  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.showDetail();
  }

  getOutfit() {
    return this.outfit;
  }

  setOutfit(collection: Collection) {
    this.outfit = collection.getOutfit(this.position);
    if (!this.outfit) {
      return;
    }
  }

  renderOutfitImage() {
    this.innerHTML = `
      <style>${styles}</style>
      <img class="loading"
          src="${config.specialsApiUrl}/csp/images/image/public/${this.outfit.imageKey}?res=low&frame=1_1"
          alt="outfit-image"
          sizes="(min-width: 1024px) 1200px, (max-width: 768px) 400px"
          srcset="${config.specialsApiUrl}/csp/images/image/public/${this.outfit.imageKey}?res=${this.resolution || 'higher' }&frame=${this.frame} 1200w,
                  ${config.specialsApiUrl}/csp/images/image/public/${this.outfit.imageKey}?res=mid&frame=${this.frame} 400w">`;

    this.querySelector('img').addEventListener("load", this.onImageLoaded);
  }

  onImageLoaded(e: Event) {
    const image = e.target as HTMLImageElement;
    image.removeEventListener("load", this.onImageLoaded);
    image.classList.remove("loading");
  }

  showDetail() {
    window.dispatchEvent(new CustomEvent("ny-show-outfit-detail", {
      detail: {
        outfit: this.outfit
      }
    }));
  }

}

window.customElements.define('outfit-image', OutfitImage);
